var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWellLit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.468 0.75H14.5319V8.42422C13.214 8.59567 12.0045 9.11244 10.9974 9.88079L5.58045 4.46385L4.2115 5.8328L9.62333 11.2446C8.84437 12.25 8.31772 13.4608 8.1383 14.7819H0.5V16.718H8.12751C8.2922 18.0422 8.80529 19.2582 9.57219 20.2714L4.1915 25.6521L5.56047 27.0211L10.9309 21.6507C11.9511 22.4474 13.1848 22.9834 14.5319 23.1586V30.7501H16.468V23.1586C17.8065 22.9845 19.0331 22.4542 20.0496 21.6659L25.427 27.0434L26.796 25.6745L21.4128 20.2912C22.188 19.2741 22.7067 18.0508 22.8725 16.718H30.5V14.7819H22.8617C22.6811 13.4518 22.1485 12.2336 21.3608 11.2242L26.777 5.80798L25.408 4.439L19.9819 9.8651C18.9789 9.10539 17.777 8.59448 16.468 8.42421V0.75ZM15.5 10.2978C18.5281 10.2978 20.9936 12.7633 20.9936 15.7914C20.9936 18.8196 18.5281 21.2851 15.5 21.2851C12.4718 21.2851 10.0064 18.8196 10.0064 15.7914C10.0064 12.7633 12.4718 10.2978 15.5 10.2978Z",
    fill: "#006EF5"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWellLit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/WellLit.2305132751a77cc1656ee121b309a701.svg";